/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, color, centerAbsolutely, mediaQuery } from 'utils/styles';
import { aniFrameCountdownBarInitial } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/initial';
import { aniFrameCountdownBarResult } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/result';
import { aniProgressBarShareTopInitial } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/initial';
import { aniProgressBarShareTopResult } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/result';
import { aniQuestionInitial } from 'components/content/shared/questionset/shared/animations/question/initial';
import { aniQuestionResult } from 'components/content/shared/questionset/shared/animations/question/result';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TEXT 2 QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    resultelements: {},
    answerset: {

    },
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            '&.answeramount-3, &.answeramount-2': {
                height: hasRewardsComponent => hasRewardsComponent ? '65%' : '60%'
            },
            '& ul': {
                width: '100%',
                height: 'auto',
                extend: centerAbsolutely,
            },
            '& .answer': {
                display: 'block',
                marginBottom: pxToRem(6),
                marginLeft: `-${pxToEm(20)}`,  //`-${spacing.sides}`,
                marginRight: `-${pxToEm(20)}`, //`-${spacing.sides}`,

                transform: 'translate3d(-150%, 0, 0)', // pull off screen to start

                animationName: 'slideInLeft',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards',

                '&:nth-child(1)': { animationDelay: '.9s' }, // delay each child animation slightly
                '&:nth-child(2)': { animationDelay: '1.1s' },
                '&:nth-child(3)': { animationDelay: '1.3s' },
                '&:nth-child(4)': { animationDelay: '1.5s' }
            }
        },

        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniProgressBarShareTopInitial],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameCountdownBarInitial, aniQuestionInitial],
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],
            '& .answerset': {
                '& .answer': {
                    '& .text': {
                        // transition: 'font-size .3s linear 0s',
                        // fontSize: '80%',
                        transition: 'transform .3s linear 0s',
                        transform: 'scale(.8) translateX(-10%)'
                    },
                    '&.selected-true': {
                        '& .uniqueanswer': {
                            background: 'none'
                        },
                        '& .icon': {
                            transition: 'background .3s linear 0s',
                            background: color.white
                        }
                    }
                }
            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            // extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],

            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        typeset: { '& .answerset': { fontSize: '105%' } }
    },
    [mediaQuery.thin]: {
        // typeset: { '& .answerset': { fontSize: '90%' } }
        typeset: {
            '& .answerset': {
                '& .answer': {
                    '& .text': { fontSize: '80%', lineHeight: '2.8', width: '95%' },
                    '& .percentagebar .number': { fontSize: '60%' }
                }
            }
        }
    }
};

// const getAnswerSetHigh = (hasRewardsComponent, numOfAnswers) => {
//     switch (numOfAnswers) {
//         case 2:
//             return hasRewardsComponent ? '60%' : '55%';
//         case 3:
//             return hasRewardsComponent ? '65%' : '60%';
//         default:
//             return hasRewardsComponent ? '70%' : '65%';
//     }
// };
